import '../fonts/montserrat-font-family.css'
import { createTheme } from '@mui/material/styles'

// ----------------------------------------
// Brand Color (default SBM)
// ----------------------------------------
const brandColorSet = {
  main: '#f36f21',
  light: '#fff3e2',
  dark: '#e9541f',
  contrastText: '#fff'
}

// ----------------------------------------
// SBM Blue
// ----------------------------------------
const primaryColorSet = {
  main: '#175499',
  light: '#e1f5fe',
  dark: '#0d3159',
  contrastText: '#fff'
}

// ----------------------------------------
// SBM Grey
// ----------------------------------------
const secondaryColorSet = {
  main: '#626366',
  light: '#e1e2e5',
  dark: '#222325',
  contrastText: '#fff'
}

// ----------------------------------------
// ERROR, WARNING, INFO, SUCCESS
// ----------------------------------------
const errorColorSet = {
  main: '#C63939',
  light: '#f4d7d7',
  // dark: '',
  contrastText: '#fff'
}
const warningColorSet = {
  main: '#ffb751',
  light: '#ff1dc',
  // dark: '',
  contrastText: '#fff'
}
const successColorSet = {
  main: '#a3c539',
  light: '#edf4d7',
  // dark: '',
  contrastText: '#fff'
}
const infoColorSet = {
  main: '#53c1f7',
  light: '#e1f5fe',
  // dark: '',
  contrastText: '#fff'
}

const theme = createTheme({
  palette: {
    type: 'light',
    brand: brandColorSet,
    primary: primaryColorSet,
    secondary: secondaryColorSet,
    error: errorColorSet,
    warning: warningColorSet,
    success: successColorSet,
    info: infoColorSet
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: brandColorSet.main
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '28px'
        },
        outlined: {
          backgroundColor: '#fff',
          '&:hover': {
            background: '#fff'
          }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '6px'
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        colorPrimary: {
          color: primaryColorSet.main
        }
      }
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          border: '0px'
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '6px'
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderTopLeftRadius: '0px',
          borderTopRightRadius: '0px'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '3px 3px 18px #0000000F',
          borderRadius: '6px',
          opacity: 1
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '0px'
        }
      }
    },
    MuiRadio: {
      styleOverrides: {
        colorPrimary: {
          color: primaryColorSet.main
        }
      }
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent'
        },
        switchBase: {
          color: '#64666b'
        },
        track: {
          backgroundColor: secondaryColorSet.light,
          opacity: 1
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          color: brandColorSet.main
        },
        indicator: {
          backgroundColor: brandColorSet.main
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#F4F5F9',
          borderTop: '1px solid',
          borderColor: secondaryColorSet.light
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid',
          borderColor: secondaryColorSet.light
        }
      }
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: primaryColorSet.light,
        color: secondaryColorSet.main
      }
    }
  },
  typography: {
    fontFamily: ['Montserrat', 'Arial', 'sans-serif'].join(',')
  }
})

export default theme
